declare global {
  interface Window {
    writeDB: MutableDB<State>;
    api: API;
  }
}

declare const __REDUX_DEVTOOLS_EXTENSION__: () => void;

import { applyMiddleware, compose, createStore, Middleware, Store } from 'redux';
import { MutableDB, reducer } from 'redux-database';
import EJSON from 'ejson';

import { initialState, State } from './state';
import { API } from './api';
import { buildInfo } from './version';
import { I18n } from '../locales/translate';
import { reloadOnMembershipChange, showReloadNotificationCompanyChanged } from './membership';

// Can't find proper type for enhancers
// eslint-disable-next-line
const enhancers: any[] = [];
const middleware: Middleware[] = [];
const localStorageVersion = 'v1';
const settingsKey = `settings-${localStorageVersion}`;
const tableKey = `tables-${localStorageVersion}`;

if (typeof __REDUX_DEVTOOLS_EXTENSION__ === 'function') {
  enhancers.push(__REDUX_DEVTOOLS_EXTENSION__());
}
const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

export const storedData = sessionStorage.getItem(settingsKey) || localStorage.getItem(settingsKey);

const savedSettings = (storedData && EJSON.parse(storedData)) || undefined;

const storedTables = localStorage.getItem(tableKey);
const savedTables: Partial<State['data']> = (storedTables && EJSON.parse(storedTables)) || {};

const loadedState: State = {
  data: { ...initialState.data, ...savedTables },
  settings: { ...initialState.settings, ...savedSettings },
};

export const store = createStore(reducer(loadedState), loadedState, composedEnhancers) as Store<State>;

export const writeDB = new MutableDB<State>(loadedState, { store });
window.writeDB = writeDB;

store.subscribe(() => {
  const state = store.getState();
  if (!state) return;
  const settings = EJSON.stringify(state.settings);
  localStorage.setItem(settingsKey, settings);
  localStorage.setItem(tableKey, EJSON.stringify({ activityLog: state.data.activityLog }));
});

reloadOnMembershipChange(settingsKey);

export const reloadNotificationFunctions = {
  companyChanged: showReloadNotificationCompanyChanged,
};

export const api = new API({
  baseUrl: '/api/v2',
  membership: async () => writeDB.get('selectedMembership'),
  headerInterceptor: async (headers) => {
    headers['X-KS-BUILD'] = buildInfo.build;
    headers['Accept-Language'] = I18n.locale;
  },
});

window.api = api;
